import { formatValue } from './common';
import { formatFieldEdition } from './summary';

import type { ChangelogDiff, ChangelogSummaryRule, FormatterContext } from './types';

export const VENUES_ORDER = 3000;

type VenueData = {
  country?: unknown;
  name?: unknown;
  type?: unknown;
};

function toVenue(value: unknown): VenueData {
  return value && typeof value === 'object' ? (value as VenueData) : {};
}

function formatAddedVenue(value: unknown): string {
  const { country, name, type } = toVenue(value);
  const details = [type, country].filter(Boolean).join(', ');
  return details ? `${formatValue(name)} (${details})` : formatValue(name);
}

/** Venues are an array: identify them by 1-based position */
function getVenueLabel(change: ChangelogDiff, { formatMessage }: FormatterContext): string {
  return `${formatMessage({ defaultMessage: 'Venue', id: 'changelogModal.message.venue' })} ${Number(change.path?.[0]) + 1}`;
}

export const venuesRules: ChangelogSummaryRule[] = [
  {
    format: change => {
      if (change.item?.kind === 'N') {
        return { category: 'added', label: formatAddedVenue(change.item.rhs) };
      }
      if (change.item?.kind === 'D') {
        return { category: 'deleted', label: formatValue(toVenue(change.item.lhs).name) };
      }
      return undefined;
    },
    order: VENUES_ORDER,
    regex: /^A$/,
    section: 'venues'
  },
  {
    format: (change, context) => ({
      category: change.rhs ? 'deleted' : 'restored',
      label: getVenueLabel(change, context)
    }),
    order: VENUES_ORDER,
    regex: /^E\.\d+\.deleted$/,
    section: 'venues'
  },
  {
    format: (change, context) => ({
      category: 'updated',
      label: `${getVenueLabel(change, context)} ${formatFieldEdition(String(change.path?.[1]), change, context)}`
    }),
    order: VENUES_ORDER,
    regex: /^[END]\.\d+\.(name|type|country)$/,
    section: 'venues'
  }
];
